import {
  assignController, click, selectAlso, setClassState, unsetClassState,
} from '../api/element-manipulation'

assignController('toggle', (element) => {
  const buttons = selectAlso(element, '[data-hook~="toggle.button"]')
  const stateElements = selectAlso(element, '[data-class-toggle-on]')

  // console.log(buttons, stateElements)

  const toggle = () => {
    if (element.dataset.toggleOn === '1') {
      setOff()
    } else {
      setOn()
    }
  }

  const setOff = () => {
    stateElements.forEach((stateElement) => {
      setTimeout(() => {
        unsetClassState(stateElement, stateElement.dataset.classToggleOn)
        setClassState(stateElement, stateElement.dataset.classToggleOff)
      }, +(stateElement.dataset.toggleDelay))
    })
    element.dataset.toggleOn = '0'
  }

  const setOn = () => {
    stateElements.forEach((stateElement) => {
      setTimeout(() => {
        unsetClassState(stateElement, stateElement.dataset.classToggleOff)
        setClassState(stateElement, stateElement.dataset.classToggleOn)
      }, +(stateElement.dataset.toggleDelay))
    })
    element.dataset.toggleOn = '1'
  }

  buttons.forEach((button) => {
    click(element, toggle)
  })

  const controller = {
    buttons,
    toggle,
    setOn,
    setOff,
  }

  return controller
})
